"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var result_message_1 = require("./serialized_data/result_message");
var API_KEY = "9463d2d2-8560-40ea-8f4e-739ac9afed2c";
var BASE_URL = "";
var JSONAPIDriver = /** @class */ (function () {
    function JSONAPIDriver() {
    }
    JSONAPIDriver.prototype.put = function (request_url, data) {
        var url = BASE_URL + "/" + request_url;
        var payload = JSON.stringify(data);
        var requestOptions = {
            method: "PUT",
            headers: {
                "Content-Length": payload.length.toString(),
                "Content-Type": "application/json",
                "X-HTTP-APIKEY": API_KEY,
            },
            body: payload,
        };
        return fetch(url, requestOptions).then(function (response) {
            if (response.ok) {
                return response.json();
            }
            else {
                return Promise.reject(response);
            }
        });
    };
    JSONAPIDriver.prototype.get = function (request_url) {
        var url = BASE_URL + "/" + request_url;
        var requestOptions = {
            method: "GET",
            headers: {
                "X-HTTP-APIKEY": API_KEY,
            },
        };
        return fetch(url, requestOptions).then(function (response) {
            if (response.ok) {
                return response.json();
            }
            else {
                return Promise.reject(response);
            }
        });
    };
    return JSONAPIDriver;
}());
var ServerDriver = /** @class */ (function (_super) {
    __extends(ServerDriver, _super);
    function ServerDriver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServerDriver.prototype.uploadTestResult = function (subjectId, experimentVersion, timestamp, letterResult, sentenceResult) {
        return this.put("api/result", (0, result_message_1.serializeResultMessage)(subjectId, experimentVersion, timestamp, letterResult, sentenceResult));
    };
    return ServerDriver;
}(JSONAPIDriver));
exports.default = ServerDriver;
